import { apiClient } from '../config/api';
import { buildQueryString } from '../config/endpoints';

export class SinistroService {
  static async list(params?: any) {
    const qs = params ? buildQueryString(params) : '';
    return apiClient.request<any>(`/sinistros${qs}`);
  }

  static async get(id: number) {
    return apiClient.request<any>(`/sinistros/${id}`);
  }

  static async create(payload: any) {
    return apiClient.request<any>(`/sinistros`, { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } });
  }

  static async update(id: number, payload: any) {
    return apiClient.request<any>(`/sinistros/${id}`, { method: 'PUT', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } });
  }

  static async remove(id: number) {
    return apiClient.request<any>(`/sinistros/${id}`, { method: 'DELETE' });
  }

  static async getByFlags(flags: string, params?: any) {
    const qs = params ? buildQueryString(params) : '';
    // Ensure Authorization header present (apiClient normally injects token,
    // but pass explicitly to be safe in contexts where caller overrides headers)
    const token = localStorage.getItem('authToken');
    const options: any = {};
    if (token) {
      options.headers = { Authorization: `Bearer ${token}` };
    }
    return apiClient.request<any>(`/sinistros/flag/${flags}${qs}`, options);
  }

  static async search(params?: any) {
    const qs = params ? buildQueryString(params) : '';
    return apiClient.request<any>(`/sinistros/search${qs}`);
  }
}

export const sinistroService = SinistroService;
